import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StaffTable from "../components/StaffTable";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const StaffPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUser = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/user/fetch`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-type": "application/json",
        },
      });

      const dataFor = await response.json();
      setLoading(false);

      if (response.status === 200) {
        setData(dataFor.data);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // ✅ Count roles
  const totalStaff = data.length;
  const electricians = data.filter((u) => u.role?.toLowerCase() === "electrician").length;
  
  const users = data.filter((u) => u.role?.toLowerCase() === "user" || u?.role.toLowerCase() === 'admin').length;

  return (
    <MasterLayout>
      <Breadcrumb title="Staff" />

      {/* Loading Spinner */}
      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}

      {/* Stats Cards */}
      {!loading && (
        <div className="row g-3 mb-3">
          {/* Total Staff */}
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-primary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mdi:account-group" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Total Staff
                    </span>
                    <h6 className="fw-semibold">{totalStaff}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Electricians */}
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-success text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mdi:lightning-bolt" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Electricians
                    </span>
                    <h6 className="fw-semibold">{electricians}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

         

          {/* Users */}
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-info text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mdi:account" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Users
                    </span>
                    <h6 className="fw-semibold">{users}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* No Staff Message */}
      {!loading && data.length === 0 && (
        <p>
          No Staff Found…{" "}
          <Link to={"/add-staff"} className="text-primary">
            Create New
          </Link>
        </p>
      )}

      {/* Staff Table */}
      {!loading && data.length > 0 && <StaffTable data={data} />}
    </MasterLayout>
  );
};

export default StaffPage;
